import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// Internal components
import Nav from "components/Nav";

// Hooks
// import { OuterClick } from "react-outer-click";

// Contexts
// import { DataContext } from "contexts/Data";

// External components
import { HiHome } from "react-icons/hi";

const MobileNav = () => {
    // const { screenWidth } = useContext(DataContext);
    const [openMobileNav, setOpenMobileNav] = useState(false);
    useEffect(() => {
        if (openMobileNav) {
            document.body.classList.add("noscroll");
        } else {
            document.body.classList.remove("noscroll");
        }
    }, [openMobileNav]);
    return (
        <div
            className={`mobile-nav ${openMobileNav ? "mobile-nav--open" : ""}`}
            onClick={() => setOpenMobileNav(!openMobileNav)}
        >
            <div
                className="mobile-nav__button"
                onClick={() => setOpenMobileNav(!openMobileNav)}
            >
                <div className="mobile-nav__button__icon">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <div className="icon-thread icon-thread-1"></div>
                    <div className="icon-thread icon-thread-2"></div>
                    <div className="icon-thread icon-thread-3"></div>
                    <div className="icon-thread icon-thread-4"></div>
                </div>
            </div>
            <div
                className="mobile-nav__content"
                // onClick={() => setOpenMobileNav(false)}
            >
                <Link to="/" className="mobile-nav__content__home">
                    <HiHome size="5rem" />
                </Link>
                <Nav />
            </div>
        </div>
    );
};

export default MobileNav;
